export default __webpack_public_path__ + "2f0c04d205717f7b30292c5251b64418.svg";